export default new Map<string, string[]>();
